import { ReactNode } from 'react';
import cn from 'classnames';
import UpgradePlanButton from '@/creditflowresearch/ui/common/components/UpgradePlanButton';
import { getProDescription } from '@/creditflowresearch/ui/common/components/organisms/constants';
import TitleWithIcon from '@creditflowresearch/uilib/TitleWithIcon';
import Flex from '@creditflowresearch/uilib/Flex';
import IconQuestion from '@creditflowresearch/uilib/Icon/IconQuestion';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';

import styles from './tileAccessFallback.module.scss';

interface ITileAccessFallbackProps {
  title: ReactNode,
  dataTest: string,
  tooltipContent?: ReactNode,
  description?: ReactNode,
  actionButton?: ReactNode,
  icon?: IconComponentType,
  className?: string,
  direction?: 'horizontal' | 'vertical',
}

const TileAccessFallback = ({
  title,
  dataTest,
  tooltipContent,
  description = getProDescription(),
  actionButton = <UpgradePlanButton />,
  direction = 'horizontal',
  icon: Icon = IconQuestion,
  className,
}: ITileAccessFallbackProps) => {
  const isVertical = direction === 'vertical';

  const renderContent = () => (
    isVertical
      ? (
        <>
          <div className={ styles.description }>{ description }</div>
          { actionButton }
        </>
      )
      : (
        <div className={ styles.bodyContainer }>
          <div className={ styles.description }>{ description }</div>
          { actionButton }
        </div>
      )
  );

  return (
    <Flex
      align="center"
      justify={ isVertical ? 'center' : 'space-between' }
      direction={ isVertical ? 'column' : 'row' }
      data-test={ dataTest }
      className={ cn(styles.container, { [styles.vertical]: isVertical }, className) }
    >
      <TitleWithIcon
        title={ title }
        tooltipContent={ tooltipContent }
        icon={ Icon }
        dataTest={ dataTest }
        className={ cn({ [styles.title]: isVertical }) }
      />

      { renderContent() }
    </Flex>
  );
};

export default TileAccessFallback;
